import { RootState } from 'app/store/rootReducer';

export const selectIsMotor = (state: RootState) =>
  state.quotationConfig.isMotorConfig;

export const selectActiveQuotation = (state: RootState) =>
  state.quotationConfig.activeQuotation;

export const selectMainOwnerSelectionData = (state: RootState) =>
  state.quotationConfig.mainOwnerSelectionData;
